import { selectors, useDispatch, useSelector } from '@sloyd/store-base';
import { Prompter } from '@sloyd/ui';
import { useMemo } from 'react';
import { $ac } from 'shared-base';

export type PrompterContainerProps = {};

export function PrompterContainer(_props: PrompterContainerProps) {
  const dispatch = useDispatch();
  const appState = useSelector(selectors.raw.$rawAppState);
  const realtimeState = useSelector(selectors.raw.$rawRealtimeState);
  const focusMode = useSelector(selectors.base.$focusMode);
  const projectType = useSelector(selectors.single.$projectType);
  const isEmployee = useSelector(selectors.base.$isEmployee);
  const { editMode, isAiRunning } = appState;
  const { isEnabled } = realtimeState;

  const callbacks = useMemo(
    () => ({
      onPrompt: (prompt: string, onlySlot: boolean) => {
        dispatch($ac('PROMPT', { prompt, onlySlot }));
      },
      onAction: (action: Action) => {
        dispatch(action);
      },
    }),
    []
  );

  if (isEnabled) {
    return null;
  }

  return (
    <Prompter
      isEmployee={isEmployee}
      mode={editMode}
      focusMode={focusMode}
      onPrompt={callbacks.onPrompt}
      isAiRunning={isAiRunning}
      projectType={projectType}
    />
  );
}

export default PrompterContainer;
